<footer class="main-footer">
  <div class="pull-right hidden-xs">
    <ng-template [ngTemplateOutlet]="footerRightComponent?.templateRef"></ng-template>
  </div>
  <ng-template [ngTemplateOutlet]="footerLeftComponent?.templateRef"></ng-template>
</footer>
